/**
 * Hash routes, so the site stays plain static files: S3 serves index.html for
 * every view and deep links / refresh / back all work without rewrite rules.
 *
 *   #/                         standings + latest week's matchups
 *   #/week/2                   standings + week 2's matchups
 *   #/team/<teamId>            one team's season
 *   #/matchup/<week>/<teamId>  the game that team played that week
 */

export type Route =
  | { name: "home"; week?: number }
  | { name: "team"; teamId: string }
  | { name: "matchup"; week: number; teamId: string }
  | { name: "notFound" };

export function parseRoute(hash: string): Route {
  const parts = hash.replace(/^#\/?/, "").split("/").filter(Boolean).map(decodeURIComponent);
  const [head, ...rest] = parts;
  const week = (s: string | undefined): number | undefined => {
    const n = Number(s);
    return Number.isInteger(n) && n > 0 ? n : undefined;
  };

  if (!head) return { name: "home" };
  if (head === "week" && rest.length === 1 && week(rest[0])) return { name: "home", week: week(rest[0]) };
  if (head === "team" && rest.length === 1) return { name: "team", teamId: rest[0]! };
  if (head === "matchup" && rest.length === 2 && week(rest[0])) {
    return { name: "matchup", week: week(rest[0])!, teamId: rest[1]! };
  }
  return { name: "notFound" };
}

const enc = encodeURIComponent;
export const href = {
  home: (): string => "#/",
  week: (week: number): string => `#/week/${week}`,
  team: (teamId: string): string => `#/team/${enc(teamId)}`,
  matchup: (week: number, teamId: string): string => `#/matchup/${week}/${enc(teamId)}`,
};
